import { Injectable } from '@angular/core';
import {
    InterFrameBilMsg,
    InterframeBizHandler,
    logProcessedMsg,
    logUnknownMsg
} from '../interframe-global.model';
import {
    isOtherHandlerMessages,
    OtherMessage
} from './interframe-other-handler.model';

@Injectable()
export class InterframeOtherHandlerService implements InterframeBizHandler {
    handleMessage(msg: InterFrameBilMsg<OtherMessage>): unknown {
        if (!isOtherHandlerMessages(msg)) {
            logUnknownMsg('InterframeOtherHandlerService', 'green', msg);
            return undefined;
        }
        logProcessedMsg('InterframeOtherHandlerService', 'lightgreen', msg);
        return undefined;
    }
}
